import { render, staticRenderFns } from "./noservice.vue?vue&type=template&id=7126be76&scoped=true"
import script from "./noservice.vue?vue&type=script&lang=js"
export * from "./noservice.vue?vue&type=script&lang=js"
import style0 from "./noservice.vue?vue&type=style&index=0&id=7126be76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126be76",
  null
  
)

export default component.exports